var LocationModel = /** @class */ (function () {
    function LocationModel(data) {
        this.streetNumber = data.streetNumber;
        this.route = data.route;
        this.city = data.city;
        this.county = data.county;
        this.state = data.state;
        this.postalCode = data.postalCode;
    }
    Object.defineProperty(LocationModel.prototype, "valid", {
        get: function () {
            var _this = this;
            var valid = true;
            Object.getOwnPropertyNames(this)
                .map(function (key) {
                if (!_this[key])
                    valid = false;
            });
            return valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LocationModel.prototype, "fullAddress", {
        get: function () {
            var address = '';
            if (this.streetNumber)
                address += this.streetNumber;
            if (address.length)
                address += ' ';
            if (this.route)
                address += this.route;
            if (address.length)
                address += ', ';
            if (this.city)
                address += this.city;
            if (address.length)
                address += ', ';
            if (this.state)
                address += this.state;
            if (this.postalCode)
                address += ' ' + this.postalCode;
            return address;
        },
        enumerable: true,
        configurable: true
    });
    return LocationModel;
}());
export { LocationModel };
